/*eslint-disable*/
import React from 'react';

// @mui/material components
import { makeStyles } from '@mui/styles';

// material ui icons
import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import ParametersIcon from '@mui/icons-material/FormatListBulleted';

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import Button from 'components/CustomButtons/Button.js';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  ThemedPrimaryBtn,
  ThemedSecondaryBtn,
} from '@themes/defaultThemeProps';

// style for this view
import styles from 'assets/jss/material-dashboard-pro-react/views/roleEditStyle.js';

// Redux
import {
  useDeleteParameterSetMutation,
  useGetClientParameterDictionaryQuery,
  useGetParameterListsQuery,
  useLazyGetClientParameterDictionaryQuery,
} from 'api/parameter.api';

const useStyles = makeStyles(styles);

export default function ParameterLists(props) {
  const classes = useStyles();

  useGetClientParameterDictionaryQuery();
  const [triggerGetClientParameterDictionary] =
    useLazyGetClientParameterDictionaryQuery();
  const { data: parameterLists } = useGetParameterListsQuery();
  const [deleteParameterSet] = useDeleteParameterSetMutation();

  const handleEditParameterSet = async (index) => {
    await triggerGetClientParameterDictionary().unwrap();
    props.history.push('/admin/parameterset', {
      parameterSet: parameterLists[index],
      new: false,
    });
  };

  const addParameterSetHandler = () => {
    props.history.push('/admin/parameterset', {
      parameterSet: null,
      new: true,
    });
  };

  const [deleteSet, setDeleteSet] = React.useState(false);
  const [currentSet, setCurrentSet] = React.useState(null);

  const handleDeleteSet = (index) => {
    setCurrentSet(parameterLists[index]);
    setDeleteSet(true);
  };

  const deleteCurrentSet = async () => {
    await deleteParameterSet(currentSet).unwrap();
    setDeleteSet(false);
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color='rose' icon>
              <CardIcon color='rose'>
                <ParametersIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Parameter Sets</h4>
              <Button
                color='rose'
                onClick={addParameterSetHandler}
                className={classes.registerButton}
              >
                + Add Parameter Set
              </Button>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  <ReactTable
                    columns={[
                      {
                        Header: 'Set Name',
                        accessor: 'name',
                        disableSortBy: true,
                        width: 200,
                      },
                      {
                        Header: 'Set Description',
                        accessor: 'description',
                        disableSortBy: true,
                        width: 200,
                      },
                      {
                        Header: 'Temporary?',
                        accessor: 'temporary',
                        disableSortBy: true,
                        width: 100,
                      },
                      {
                        Header: 'Start Date',
                        accessor: 'startDate',
                        disableSortBy: true,
                        width: 100,
                      },
                      {
                        Header: 'End Date',
                        accessor: 'endDate',
                        disableSortBy: true,
                        width: 100,
                      },
                      {
                        Header: 'Version',
                        accessor: 'version',
                        disableSortBy: true,
                        width: 100,
                      },
                      {
                        Header: 'Actions',
                        accessor: 'actions',
                        disableFilters: true,
                        disableSortBy: true,
                        width: 100,
                        style: {
                          marginBottom: 20,
                        },
                      },
                    ]}
                    data={parameterLists?.map((list, key) => {
                      const listRow = {
                        id: key,
                        name: list.name,
                        description: list.description,
                        temporary: list.temporary ? 'True' : 'False',
                        startDate: list.start_date
                          ? new Date(list.start_date).toDateString()
                          : '',
                        endDate: list.end_date
                          ? new Date(list.end_date).toDateString()
                          : '',
                        version: list.version,
                        actions: (
                          <div className='actions-left'>
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => handleEditParameterSet(key)}
                              color='warning'
                              className='edit'
                            >
                              <Edit />
                            </Button>
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => handleDeleteSet(key)}
                              color='warning'
                              className='edit'
                            >
                              <Delete />
                            </Button>
                          </div>
                        ),
                      };
                      return listRow;
                    }) ?? []}
                    options={{
                      pageSize: parameterLists?.length,
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <Dialog
        open={deleteSet}
        onClose={() => setDeleteSet(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Delete {currentSet ? currentSet.name : ''} (
          {currentSet ? currentSet.description : ''})?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Deleting this parameter set cannot be undone!
            <br />
            Press Delete to confirm, or Cancel to cancel.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ThemedSecondaryBtn onClick={() => setDeleteSet(false)}>
            Cancel
          </ThemedSecondaryBtn>
          <ThemedPrimaryBtn
            onClick={() => deleteCurrentSet()}
            color='primary'
            autoFocus
          >
            Delete
          </ThemedPrimaryBtn>
        </DialogActions>
      </Dialog>
    </>
  );
}
